module.exports = __webpack_public_path__ + "static/media/sports.8c8a17c4.png";